export const CORDAGE = [
    {
        id: 0,
        name: "Nút Thắt Cầm",
        quantity: "1 Cái"
    },
    {
        id: 1,
        name: "Nút Thắt Nan",
        quantity: "1 Cái"
    },
    {
        id: 2,
        name: "Nút Thắt Co Dãn",
        quantity: "1 Cái"
    },
    {
        id: 3,
        name: "Nút Thắt Tấm Che",
        quantity: "1 Cái"
    },
    {
        id: 4,
        name: "Nút Thắt Khăn",
        quantity: "1 Cái"
    },
    {
        id: 5,
        name: "Nút Thắt Miệng Chai",
        quantity: "1 Cái"
    },
    {
        id: 6,
        name: "Nút Thắt Chữ Thập",
        quantity: "1 Cái"
    },
    {
        id: 7,
        name: "Nút Thắt Kéo(Có Lỗ Và Không Có Lỗ)",
        quantity: "1 Cái"
    },
    {
        id: 8,
        name: "Nút Thắt Nối Dây",
        quantity: "1 Cái"
    },
    {
        id: 9,
        name: "Nút Thắt Đồ",
        quantity: "1 Cái"
    },
    {
        id: 10,
        name: "Nút Thắt Kép",
        quantity: "1 Cái"
    },
    {
        id: 11,
        name: "Nút Thắt Thu Dây",
        quantity: "1 Cái"
    },
    {
        id: 12,
        name: "Nút Thắt Thông Dụng",
        quantity: "1 Cái"
    },
    {
        id: 13,
        name: "Nút Thắt Đơn",
        quantity: "1 Cái"
    },
    {
        id: 14,
        name: "Nút Thắt Lưới",
        quantity: "1 Cái"
    },
    {
        id: 15,
        name: "Nút Thắt Siêu Chắc",
        quantity: "1 Cái"
    },
    {
        id: 16,
        name: "Nút Thắt Điều Chỉnh",
        quantity: "1 Cái"
    },
    {
        id: 17,
        name: "Nút Thắt Vòng",
        quantity: "1 Cái"
    },
    {
        id: 18,
        name: "Nút Thắt Giày",
        quantity: "1 Cái"
        
    },
    {
        id: 19,
        name: "Nút Thắt Trơn",
        quantity: "1 Cái"
    },
    {
        id: 20,
        name: "Nút Thắt Chốt Cầu",
        quantity: "1 Cái"
    },
    {
        id: 21,
        name: "Nút Thắt Trói",
        quantity: "1 Cái"
    },
    {
        id: 22,
        name: "Nút Thắt Bó Rau",
        quantity: "1 Cái"
    },
    {
        id: 23,
        name: "Nút Thắt Tự Tháo",
        quantity: "1 Cái"
    },
    {
        id: 24,
        name: "Nút Thắt Móc Câu",
        quantity: "1 Cái"
    },
    {
        id: 25,
        name: "Nút Thắt Đôi Đơn",
        quantity: "1 Cái"
    },
    {
        id: 26,
        name: "Nút Thắt Lấy Đồ",
        quantity: "1 Cái"
    },
    {
        id: 27,
        name: "Nút Thắt Miệng Túi",
        quantity: "1 cái"
    },
    {
        id: 28,
        name: "Nút Thắt Số 8 Bẫy",
        quantity: "1 cái"
    },
    {
        id: 29,
        name: "Nút Xu Tiếp Dây",
        quantity: "1 cái"
    },
    {
        id: 30,
        name: "Nút Xu Bao Bì",
        quantity: "1 Cái"
    },
    {
        id: 31,
        name: "Nút Xu Cơ Bản",
        quantity: "1 cái"
    },
    {
        id: 32,
        name: "Nút Khâu Liền",
        quantity: "1 Cái"
    },
    {
        id: 33,
        name: "Nút Khâu Giấu Chỉ",
        quantity: "1 Cái"
    },
    {
        id: 34,
        name: "Nút Khâu Nội Bì",
        quantity: "1 Cái"
    },
    {
        id: 35,
        name: "Nút Khâu Vắt Cổ",
        quantity: "1 Cái"
    }
]
